import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          top: 100%;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          bottom: 100%;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      min-width: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  animation: ", "\n    0.35s ease-out;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    max-height: 0;\n    opacity: 0;\n  }\n\n  40% {\n    max-height: 80px;\n    opacity: 0;\n  }\n\n  100% {\n    max-height: ", "px;\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { PureComponent } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Button } from '@scp/ui-shared/components/buttons';
import { baselineToRem } from '@scp/ui-shared/theme/utils'; // eslint-disable-next-line import/no-relative-parent-imports

import { getFilteredOptionsToToggleSelect, flattenOptions } from './utils'; // eslint-disable-next-line import/no-relative-parent-imports

import { Dropdown } from '../dropdown';
import { DropdownMenuHeader } from './DropdownMenuHeader';
var TEXT = {
  SELECTED: 'Selected',
  SELECT_ALL: 'Select All',
  DESELECT_ALL: 'Deselect All'
};
var MENU_WRAPPER_HEIGHT = 300;

var appearAnimation = function appearAnimation(dropdownMenuHeight) {
  return keyframes(_templateObject(), dropdownMenuHeight);
};

var Wrapper = styled(Dropdown)(_templateObject2(), function (props) {
  return appearAnimation(props.dropdownMenuHeight ? props.dropdownMenuHeight : MENU_WRAPPER_HEIGHT);
}, function (props) {
  return props.dropdownHasMinWidth && css(_templateObject3(), baselineToRem(83));
}, function (_ref) {
  var placement = _ref.placement;
  return placement === 'top' ? css(_templateObject4()) : css(_templateObject5());
});
export var DropdownMenu = /*#__PURE__*/function (_PureComponent) {
  _inherits(DropdownMenu, _PureComponent);

  var _super = _createSuper(DropdownMenu);

  function DropdownMenu() {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _super.apply(this, arguments);
    /*
     * We don't get filtered values from the props of `react-select`,
     * but we get a method to filter, so this method filters results using the same logic
     * as built-in `react-select` method.
     *
     * This also can be replaced as a prop given to `SelectField` (see `react-select` docs).
     */

    _this.filterOptions = function (options) {
      var _this$props = _this.props,
          searchValue = _this$props.searchValue,
          onFilterOption = _this$props.onFilterOption;
      var flatOptions = flattenOptions(options);
      return onFilterOption ? flatOptions.filter(function (option) {
        return onFilterOption(option, searchValue || '');
      }) : flatOptions;
    };

    _this.toggleSelectAll = function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          selectedOptions = _this$props2.selectedOptions;
      onChange(getFilteredOptionsToToggleSelect(selectedOptions, _this.filteredSelectedOptions, _this.filteredAllOptions), {
        action: 'set-value'
      });
    };

    _this.onValueChange = function (value) {
      var onChange = _this.props.onChange;
      onChange(value, {
        action: 'set-value'
      });
    };

    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          showSelectAll = _this$props3.showSelectAll,
          onContentMouseDown = _this$props3.onContentMouseDown,
          onContentMouseMove = _this$props3.onContentMouseMove,
          additionalMenuHeaderRenderer = _this$props3.additionalMenuHeaderRenderer,
          selectedCountTitle = _this$props3.selectedCountTitle,
          selectedOptions = _this$props3.selectedOptions,
          dropdownMenuHeight = _this$props3.dropdownMenuHeight,
          dropdownHasMinWidth = _this$props3.dropdownHasMinWidth,
          innerRef = _this$props3.innerRef,
          placement = _this$props3.placement;
      var allCount = this.filteredAllOptions.length;
      var selectedCount = this.filteredSelectedOptions.length;
      /*
       * Without `onMouseDown` on parent, clicking outside of <Menu /> (in this case MenuHeader),
       * would close the dropdown immediately.
       */

      return React.createElement(Wrapper, {
        onMouseDown: onContentMouseDown,
        onMouseMove: onContentMouseMove,
        dropdownMenuHeight: dropdownMenuHeight,
        dropdownHasMinWidth: dropdownHasMinWidth,
        placement: placement
      }, !!additionalMenuHeaderRenderer && additionalMenuHeaderRenderer(this.onValueChange, selectedOptions), showSelectAll && React.createElement(DropdownMenuHeader, {
        title: selectedCountTitle || TEXT.SELECTED,
        selectedItemsCount: selectedCount,
        showTopBorder: !!additionalMenuHeaderRenderer,
        actionButton: React.createElement(Button, {
          secondary: true,
          onClick: this.toggleSelectAll
        }, selectedCount === allCount ? TEXT.DESELECT_ALL : TEXT.SELECT_ALL)
      }), React.createElement("div", {
        ref: innerRef
      }, children));
    }
  }, {
    key: "filteredSelectedOptions",
    get: function get() {
      return this.filterOptions(this.props.selectedOptions);
    }
  }, {
    key: "filteredAllOptions",
    get: function get() {
      return this.filterOptions(this.props.options);
    }
  }]);

  return DropdownMenu;
}(PureComponent);
DropdownMenu.defaultProps = {
  children: null,
  options: [],
  selectedOptions: [],
  showSelectAll: false,
  searchValue: '',
  selectedCountTitle: TEXT.SELECTED,
  onContentMouseDown: function onContentMouseDown() {
    return null;
  },
  onContentMouseMove: function onContentMouseMove() {
    return null;
  }
};